<app-fullscreen 
  [template]="targetTmp"
  [showFullScreenBtn]="enableFullscreen" 
  [showDownloadBtn]="enableDownload"
  [isDownloadLoading]="isFileDownloading"
  (fullscreenToggle)="fullscreenToggle()"
  (downloadFile)="downloadFile()">
</app-fullscreen>

<ng-template #targetTmp>
  <iframe class="iframe" width="100%" height="100%" frameBorder="0" allow="fullscreen" title="" #iframe></iframe>
</ng-template>
